(function () {
  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return [].slice.call((root || document).querySelectorAll(sel));
  }

  function bindResize(root, fn) {
    if (root._heathenResizeHandler) {
      window.removeEventListener('resize', root._heathenResizeHandler);
    }
    var timer;
    root._heathenResizeHandler = function () {
      clearTimeout(timer);
      timer = setTimeout(fn, 80);
    };
    window.addEventListener('resize', root._heathenResizeHandler, { passive: true });
  }

  function initDesktop(root) {
    var viewport = qs(root, '.heathen-pdp-gallery__viewport');
    var track = qs(root, '[data-heathen-track]');
    if (!viewport || !track) return;

    var current = 0;

    function slides() {
      return qsa(track, '.slide:not(.slide-spacer)');
    }

    function realCount() {
      return slides().length;
    }

    function slideWidthPx() {
      return viewport.getBoundingClientRect().width / 1.5;
    }

    function maxIndex() {
      return Math.max(0, realCount() - 1);
    }

    function apply() {
      if (realCount() === 0) return;
      var w = slideWidthPx();
      qsa(track, '.slide').forEach(function (sl) {
        sl.style.flex = '0 0 ' + w + 'px';
        sl.style.width = w + 'px';
      });
      var offset = current * w;
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      track.style.transition = 'transform 0.3s ease-out';

      var productPage = root.closest('.product-page');
      if (productPage) {
        qsa(productPage, '[data-heathen-thumbs] .thumbnail').forEach(function (th, i) {
          th.classList.toggle('selected', i === current);
        });
      }
    }

    function goTo(index) {
      if (realCount() === 0) return;
      if (index < 0) index = 0;
      if (index > maxIndex()) index = maxIndex();
      current = index;
      apply();
    }

    function next() {
      if (current < maxIndex()) goTo(current + 1);
    }

    function prev() {
      if (current > 0) goTo(current - 1);
    }

    root.__heathenGalleryApi = {
      goTo: goTo,
      next: next,
      prev: prev,
      apply: apply,
      reset: function () {
        current = 0;
        apply();
      },
    };

    bindResize(root, apply);

    var productPage = root.closest('.product-page');
    if (productPage && !productPage.dataset.heathenGalleryDelegation) {
      productPage.dataset.heathenGalleryDelegation = '1';
      productPage.addEventListener('click', function (e) {
        var desk = qs(productPage, '[data-heathen-pdp-gallery="desktop"]');
        var api = desk && desk.__heathenGalleryApi;
        if (!api) return;
        if (e.target.closest('[data-heathen-gallery-prev]')) {
          e.preventDefault();
          api.prev();
        }
        if (e.target.closest('[data-heathen-gallery-next]')) {
          e.preventDefault();
          api.next();
        }
        var th = e.target.closest('[data-heathen-thumbs] .thumbnail');
        if (th && th.dataset.heathenSlideIndex != null) {
          var idx = parseInt(th.dataset.heathenSlideIndex, 10);
          if (!isNaN(idx)) api.goTo(idx);
        }
      });
    }

    if (realCount() > 0) apply();
  }

  function initMobile(root) {
    var viewport = qs(root, '.heathen-pdp-gallery__viewport');
    var track = qs(root, '[data-heathen-track]');
    if (!viewport || !track) return;

    if (typeof viewport._heathenSwipeTeardown === 'function') {
      viewport._heathenSwipeTeardown();
      viewport._heathenSwipeTeardown = null;
    }

    var current = 0;

    function slideEls() {
      return qsa(track, '.mobile-slide');
    }

    function n() {
      return slideEls().length;
    }

    function vw() {
      return viewport.getBoundingClientRect().width;
    }

    function apply() {
      var slides = slideEls();
      if (slides.length === 0) return;
      var w = vw();
      slides.forEach(function (sl) {
        sl.style.flex = '0 0 ' + w + 'px';
        sl.style.width = w + 'px';
      });
      track.style.transform = 'translate3d(' + -current * w + 'px, 0, 0)';
      track.style.transition = 'transform 0.3s ease-out';
      var mc = root.closest('.main-image-container');
      var inds = mc ? qsa(mc, '[data-heathen-mobile-indicators] .mobile-indicator') : [];
      inds.forEach(function (ind, i) {
        ind.classList.toggle('active', i === current);
      });
    }

    function goTo(i) {
      if (n() === 0) return;
      if (i < 0) i = 0;
      if (i > n() - 1) i = n() - 1;
      current = i;
      apply();
    }

    root.__heathenMobileApi = { goTo: goTo, apply: apply, reset: function () {
      current = 0;
      apply();
    } };

    bindResize(root, apply);

    if (n() > 0) apply();

    var dragState = null;

    function endDrag(e, cancelled) {
      if (!dragState || e.pointerId !== dragState.pointerId) return;
      var ds = dragState;
      dragState = null;
      try {
        if (viewport.hasPointerCapture(e.pointerId)) {
          viewport.releasePointerCapture(e.pointerId);
        }
      } catch (err) {}
      viewport.classList.remove('heathen-pdp-gallery__viewport--dragging');
      if (cancelled) {
        apply();
        return;
      }
      if (ds.lockedHorizontal) {
        var dx = e.clientX - ds.startX;
        var threshold = Math.max(40, vw() * 0.12);
        if (dx < -threshold && current < n() - 1) goTo(current + 1);
        else if (dx > threshold && current > 0) goTo(current - 1);
        else apply();
      } else {
        apply();
      }
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (n() < 2) return;
      var w = vw();
      dragState = {
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        startTranslate: -current * w,
        lockedHorizontal: null,
      };
      try {
        viewport.setPointerCapture(e.pointerId);
      } catch (err) {}
      viewport.classList.add('heathen-pdp-gallery__viewport--dragging');
    }

    function onPointerMove(e) {
      if (!dragState || e.pointerId !== dragState.pointerId) return;
      var dx = e.clientX - dragState.startX;
      var dy = e.clientY - dragState.startY;
      if (dragState.lockedHorizontal === null && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
        dragState.lockedHorizontal = Math.abs(dx) >= Math.abs(dy);
        if (!dragState.lockedHorizontal) {
          endDrag(e, true);
          return;
        }
      }
      if (!dragState.lockedHorizontal) return;
      e.preventDefault();
      var w = vw();
      var tx = dragState.startTranslate + dx;
      var lower = -(n() - 1) * w;
      var upper = 0;
      if (tx < lower) tx = lower + (tx - lower) * 0.25;
      if (tx > upper) tx = upper + (tx - upper) * 0.25;
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + tx + 'px, 0, 0)';
    }

    function onPointerUp(e) {
      endDrag(e, false);
    }

    function onPointerCancel(e) {
      endDrag(e, true);
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerCancel);

    viewport._heathenSwipeTeardown = function () {
      viewport.removeEventListener('pointerdown', onPointerDown);
      viewport.removeEventListener('pointermove', onPointerMove, { passive: false });
      viewport.removeEventListener('pointerup', onPointerUp);
      viewport.removeEventListener('pointercancel', onPointerCancel);
      dragState = null;
      viewport.classList.remove('heathen-pdp-gallery__viewport--dragging');
    };
  }

  function rebuildFromSource(magentoRoot) {
    var source = qs(document, '.heathen-pdp-magento-source media-gallery ul');
    if (!source) return;

    var items = qsa(source, 'li[data-media-id]');
    var urls = [];
    items.forEach(function (li) {
      var img = qs(li, 'img');
      if (img && img.src) urls.push({ src: img.src, alt: img.alt || '' });
    });
    if (urls.length === 0) return;

    var deskRoot = qs(magentoRoot, '[data-heathen-pdp-gallery="desktop"]');
    var mobRoot = qs(magentoRoot, '[data-heathen-pdp-gallery="mobile"]');
    var deskTrack = deskRoot ? qs(deskRoot, '[data-heathen-track]') : null;
    var mobTrack = mobRoot ? qs(mobRoot, '[data-heathen-track]') : null;
    var thumbs = qs(magentoRoot, '[data-heathen-thumbs]');

    function fillTrack(track, isMobile) {
      if (!track) return;
      track.innerHTML = '';
      urls.forEach(function (u, i) {
        var wrap = document.createElement('div');
        wrap.className = isMobile ? 'mobile-slide' : 'slide';
        wrap.setAttribute('data-heathen-slide', String(i));
        var im = document.createElement('img');
        im.src = u.src;
        im.alt = u.alt;
        im.className = isMobile ? 'mobile-main-image' : 'main-image';
        im.loading = i === 0 ? 'eager' : 'lazy';
        im.draggable = false;
        wrap.appendChild(im);
        track.appendChild(wrap);
      });
      if (!isMobile) {
        var sp = document.createElement('div');
        sp.className = 'slide slide-spacer';
        sp.setAttribute('data-heathen-spacer', '');
        sp.setAttribute('aria-hidden', 'true');
        sp.innerHTML = '<div class="spacer-placeholder"></div>';
        track.appendChild(sp);
      }
    }

    if (thumbs) {
      thumbs.innerHTML = '';
      urls.forEach(function (u, i) {
        var im = document.createElement('img');
        im.src = u.src;
        im.alt = u.alt;
        im.className = 'thumbnail' + (i === 0 ? ' selected' : '');
        im.dataset.heathenSlideIndex = String(i);
        thumbs.appendChild(im);
      });
    }

    fillTrack(deskTrack, false);
    fillTrack(mobTrack, true);

    var indHost = qs(magentoRoot, '[data-heathen-mobile-indicators]');
    if (indHost) {
      indHost.innerHTML = '';
      urls.forEach(function (_, i) {
        var s = document.createElement('span');
        s.className = 'mobile-indicator' + (i === 0 ? ' active' : '');
        s.setAttribute('data-heathen-indicator', String(i));
        s.setAttribute('role', 'button');
        s.setAttribute('tabindex', '0');
        indHost.appendChild(s);
      });
    }

    if (deskRoot) {
      initDesktop(deskRoot);
      if (deskRoot.__heathenGalleryApi) deskRoot.__heathenGalleryApi.reset();
    }
    if (mobRoot) {
      initMobile(mobRoot);
      if (mobRoot.__heathenMobileApi) mobRoot.__heathenMobileApi.reset();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var magentoRoot = document.querySelector('.heathen-pdp-magento .product-page');
    if (!magentoRoot) return;

    if (!magentoRoot.dataset.heathenMobileIndDelegation) {
      magentoRoot.dataset.heathenMobileIndDelegation = '1';
      magentoRoot.addEventListener('click', function (e) {
        var ind = e.target.closest('[data-heathen-mobile-indicators] .mobile-indicator');
        if (!ind) return;
        var mobRoot = qs(magentoRoot, '[data-heathen-pdp-gallery="mobile"]');
        var api = mobRoot && mobRoot.__heathenMobileApi;
        if (!api) return;
        var idx = parseInt(ind.getAttribute('data-heathen-indicator'), 10);
        if (!isNaN(idx)) api.goTo(idx);
      });
      magentoRoot.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var ind = e.target.closest('[data-heathen-mobile-indicators] .mobile-indicator');
        if (!ind) return;
        e.preventDefault();
        var mobRoot = qs(magentoRoot, '[data-heathen-pdp-gallery="mobile"]');
        var api = mobRoot && mobRoot.__heathenMobileApi;
        if (!api) return;
        var idx = parseInt(ind.getAttribute('data-heathen-indicator'), 10);
        if (!isNaN(idx)) api.goTo(idx);
      });
    }

    qsa(magentoRoot, '[data-heathen-pdp-gallery="desktop"]').forEach(initDesktop);
    qsa(magentoRoot, '[data-heathen-pdp-gallery="mobile"]').forEach(initMobile);

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        requestAnimationFrame(function () {
          rebuildFromSource(magentoRoot);
        });
      });
    }
  });
})();
